<template>
  <div class="login">
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"
    />
    <div class="top">
      <MarketplaceLogo :small="true" disabled />
    </div>
    <div class="login-container">
      <CentralAuth mode="login" />
    </div>
  </div>
</template>

<script>
import CentralAuth from 'src/app/components/centralAuth/CentralAuth.vue';
import MarketplaceLogo from 'commons/logos/MarketplaceLogo.vue';

export default {
  name: 'Login',
  components: {
    CentralAuth,
    MarketplaceLogo,
  },
};
</script>

<style lang="scss">
#application.state-partnerarea-login {
  min-width: 0;
  overflow-y: initial;

  #main-content {
    overflow: initial;
  }

  .help-panel-wrapper {
    display: none;
  }
}
</style>
